import { startOfDay, isAfter, isBefore } from 'date-fns';
import type { CollaboratorAllocation } from '@/features/Collaborators/Models';
import { AllocationTypes } from '@/features/Collaborators/Models';

const getDate = (value?: any | null): Date | null => {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return value;
  }

  if (typeof value.toDate === 'function') {
    return value.toDate();
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const isAbsence = (allocation: CollaboratorAllocation): boolean =>
  allocation.allocationType === AllocationTypes.Absence;

export const isActiveOnDate = (
  allocation: CollaboratorAllocation,
  date: Date
): boolean => {
  const startDate = getDate(allocation.startDate);
  const endDate = getDate(allocation.endDate);
  if (!startDate) {
    return false;
  }

  const currentDay = startOfDay(date);
  const startsOnOrBefore = !isAfter(startOfDay(startDate), currentDay);
  const endsAfter =
    !endDate || !isBefore(startOfDay(endDate), currentDay);

  return startsOnOrBefore && endsAfter;
};

export const isIgnoredForOccupation = (allocation: CollaboratorAllocation): boolean =>
  allocation.allocationType === AllocationTypes.Commercial ||
  allocation.allocationType === AllocationTypes.Provisional;
